import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'Material',
    column_type: 'id',
    label_key_path: 'material.id',
  },
  created_at: {
    model_name: 'Material',
    column_type: 'datetime',
    label_key_path: 'material.createdAt',
  },
  updated_at: {
    model_name: 'Material',
    column_type: 'datetime',
    label_key_path: 'material.updatedAt',
  },
  name: {
    model_name: 'Material',
    column_type: 'string',
    label_key_path: 'material.name',
  },
  sku: {
    model_name: 'Material',
    column_type: 'string',
    label_key_path: 'material.sku',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
